import { Severity } from "types/common-types";

export type FlushMessageId =
  | "flushRedisCacheSucceeded"
  | "flushRedisCachePartial"
  | "flushRedisCacheAllNodesFailed"
  | "flushRedisCacheFailed";

export type FlushFeedback = {
  messageId: FlushMessageId;
  severity: Severity;
};

export const resolveFlushFeedback = (
  nodesFlushed: number | undefined,
  nodesTotal: number | undefined,
): FlushFeedback => {
  if (!nodesTotal || nodesFlushed === undefined) {
    return { messageId: "flushRedisCacheFailed", severity: Severity.Error };
  }

  if (nodesFlushed === 0) {
    return {
      messageId: "flushRedisCacheAllNodesFailed",
      severity: Severity.Error,
    };
  }

  if (nodesFlushed < nodesTotal) {
    return {
      messageId: "flushRedisCachePartial",
      severity: Severity.Warning,
    };
  }

  return { messageId: "flushRedisCacheSucceeded", severity: Severity.Success };
};
